import React from 'react';
import { Alert, Col, ControlLabel, Row } from 'react-bootstrap';

const BlowoutRepetitions = ({ blowoutRepetitions }) => (
    <Alert bsStyle="warning">
        <Row>
            <Col sm={6}>
                <Row>
                    <Col componentClass={ControlLabel} sm={4}>
                        Blow Out Repetitions
                    </Col>
                    <Col sm={8}>{blowoutRepetitions}</Col>
                </Row>
            </Col>
        </Row>
    </Alert>
);

export default BlowoutRepetitions;
